<div class="commonMastersContainer" *transloco="let translateMsg" appFileDragDetector>
    <mat-drawer-container class="drawerContainer" autosize>
        <mat-drawer #drawer class="masterMatDrawer" mode="side" disableClose position="end">
            <ng-container
                *ngIf="
                    !unassignMaster &&
                    !downloadMasterFlag &&
                    !uploadMasterFlag &&
                    !isUploadedFiles &&
                    !synchronizeFlag &&
                    !notificationFlag &&
                    !showRequests &&
                    editRecord?.hasFields
                ">
                <div class="userMainTableConatiner">
                    <div class="settingsHeader masterDataSettings">
                        <span class="settingsNameText" [textContent]="translateMsg('Master Data for') + ': ' + masterDataName"></span>
                        <div class="settingsDataActionsContainer">
                            <material-button
                                [buttonType]="'icon'"
                                [classList]="['actionButtons']"
                                #errorMessagesTrigger
                                [matMenuTriggerFor]="messagesMenu"
                                [titleText]="translateMsg('Errors and Warnings')"
                                *ngIf="editRecord?.errors?.length > 0 || editRecord?.warnings?.length > 0"
                                [prefixIcon]="'info'"
                                [prefixIconType]="'material'"></material-button>
                            <mat-icon [title]="translateMsg('Close')" class="closeIcon" aria-hidden="true" (click)="toggleSliders()">
                                cancel
                            </mat-icon>
                        </div>
                    </div>
                    <div class="masterCard ps position-relative" [perfectScrollbar]>
                        <div class="row" *ngIf="editRecord?.hasFields">
                            <div class="masterChildContainer col-12">
                                <div
                                    class="masterAcionField !overflow-auto"
                                    [ngClass]="isFromEnInvoice ? '!max-h-[calc(100vh-18rem)]' : '!max-h-[calc(100vh-16rem)]'">
                                    <ng-container *ngIf="parentPrimaryKeyColumns?.length !== 0">
                                        <ng-container *ngFor="let parentKeyColumn of parentPrimaryKeyColumns">
                                            <ng-container
                                                *ngIf="
                                                    !updateRecord &&
                                                    parentRecord &&
                                                    parentPrimaryKeyValues &&
                                                    parentKeyColumn?.id &&
                                                    parentPrimaryKeyValues[parentKeyColumn.id]
                                                ">
                                                <material-select
                                                    class="col-4 masterField"
                                                    [options]="parentPrimaryKeyValues[parentKeyColumn.id]"
                                                    [placeholder]="parentKeyColumn.displayName"
                                                    [name]="parentKeyColumn.displayName"
                                                    [required]="true"
                                                    [model]="editRecord.fields[parentKeyColumn.id].value"
                                                    (modelChange)="
                                                        editRecord.fields[parentKeyColumn.id].value = $event;
                                                        getDependentPrimaryValues(parentKeyColumn.id)
                                                    "
                                                    [errors]="editRecord.fields[parentKeyColumn.id].message.errors"
                                                    [title]="parentKeyColumn.displayName"
                                                    [warnings]="editRecord.fields[parentKeyColumn.id].message.warnings"
                                                    disableOptionCentering></material-select>
                                            </ng-container>
                                            <ng-container
                                                *ngIf="updateRecord && parentKeyColumn?.id && editRecord?.fields[parentKeyColumn.id]">
                                                <material-input
                                                    [autofocus]="false"
                                                    class="col-4 masterField"
                                                    [placeholder]="parentKeyColumn.displayName"
                                                    [model]="editRecord.fields[parentKeyColumn.id].value"
                                                    (modelChange)="editRecord.fields[parentKeyColumn.id].value = $event"
                                                    [disabled]="updateRecord"
                                                    [errors]="editRecord.fields[parentKeyColumn.id].message.errors"
                                                    [warnings]="editRecord.fields[parentKeyColumn.id].message.warnings"
                                                    [required]="true"
                                                    [description]="editRecord.fields[parentKeyColumn.id]?.description"></material-input>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngFor="let fieldId of editRecord?.fields | ObjNgFor">
                                        <ng-container *ngIf="checkFieldType(fieldId) && hiddenFields.indexOf(fieldId) === -1">
                                            <ng-container
                                                *ngIf="
                                                    masterKeyMetaData[fieldId] !== undefined &&
                                                    masterKeyMetaData[fieldId].parentTableId !== undefined
                                                ">
                                                <material-select
                                                    [options]="$any(parentPrimaryKeyValues)"
                                                    [placeholder]="editRecord.fields[fieldId].displayName"
                                                    [model]="editRecord.fields[fieldId].value"
                                                    [errors]="editRecord.fields[fieldId].message.errors"
                                                    [warnings]="editRecord.fields[fieldId].message.warnings"
                                                    (modelChange)="editRecord.fields[fieldId].value = $event"
                                                    [description]="editRecord.fields[fieldId].description"></material-select>
                                            </ng-container>
                                            <ng-container
                                                *ngIf="
                                                    masterKeyMetaData[fieldId] !== undefined &&
                                                    masterKeyMetaData[fieldId].parentTableId === undefined &&
                                                    masterKeyMetaData[fieldId].dataType === 'STRING' &&
                                                    masterKeyMetaData[fieldId].uiTypeMetadata !== 'PASSWORD' &&
                                                    masterKeyMetaData[fieldId].uiTypeMetadata !== 'TEXTAREA'
                                                ">
                                                <material-input
                                                    [autofocus]="false"
                                                    class="col-4 masterField"
                                                    [placeholder]="editRecord.fields[fieldId].displayName"
                                                    [model]="editRecord.fields[fieldId].value"
                                                    (focusout)="onFocusOut(fieldId)"
                                                    (modelChange)="editRecord.fields[fieldId].value = $event"
                                                    [disabled]="editRecord.fields[fieldId].primaryKey && updateRecord"
                                                    [required]="editRecord.fields[fieldId].mandatory"
                                                    [errors]="editRecord.fields[fieldId].message.errors"
                                                    [warnings]="editRecord.fields[fieldId].message.warnings"
                                                    [description]="editRecord.fields[fieldId].description"></material-input>
                                            </ng-container>
                                            <ng-container
                                                *ngIf="
                                                    masterKeyMetaData[fieldId] !== undefined &&
                                                    masterKeyMetaData[fieldId].parentTableId === undefined &&
                                                    masterKeyMetaData[fieldId].dataType === 'STRING' &&
                                                    masterKeyMetaData[fieldId].uiTypeMetadata === 'TEXTAREA'
                                                ">
                                                <material-textarea
                                                    class="col-4 masterField"
                                                    [placeholder]="editRecord.fields[fieldId].displayName"
                                                    [model]="editRecord.fields[fieldId].value"
                                                    (modelChange)="editRecord.fields[fieldId].value = $event"
                                                    [required]="editRecord.fields[fieldId].mandatory"
                                                    [errors]="editRecord.fields[fieldId].message.errors"
                                                    [warnings]="editRecord.fields[fieldId].message.warnings"
                                                    [description]="editRecord.fields[fieldId].description"></material-textarea>
                                            </ng-container>
                                            <ng-container
                                                *ngIf="
                                                    masterKeyMetaData[fieldId] !== undefined &&
                                                    masterKeyMetaData[fieldId].parentTableId === undefined &&
                                                    masterKeyMetaData[fieldId].dataType === 'STRING' &&
                                                    masterKeyMetaData[fieldId].uiTypeMetadata === 'PASSWORD'
                                                ">
                                                <material-input-password
                                                    class="col-4 masterField"
                                                    [autofocus]="false"
                                                    [name]="editRecord.fields[fieldId].displayName"
                                                    [placeholder]="editRecord.fields[fieldId].displayName"
                                                    [model]="editRecord.fields[fieldId].value"
                                                    [debounceAfter]="1000"
                                                    (modelChange)="editRecord.fields[fieldId].value = $event"
                                                    [required]="editRecord.fields[fieldId].mandatory"
                                                    [errors]="editRecord.fields[fieldId].message.errors"
                                                    [warnings]="editRecord.fields[fieldId].message.warnings"
                                                    [description]="editRecord.fields[fieldId].description"></material-input-password>
                                            </ng-container>
                                            <ng-container
                                                *ngIf="
                                                    masterKeyMetaData[fieldId] !== undefined &&
                                                    masterKeyMetaData[fieldId].parentTableId === undefined &&
                                                    masterKeyMetaData[fieldId].dataType === 'BOOLEAN'
                                                ">
                                                <div class="col-4 radioContainer">
                                                    <div class="col-6 radioItem">
                                                        <span [textContent]="editRecord.fields[fieldId].displayName"></span>
                                                        <material-button
                                                            [buttonType]="'icon'"
                                                            [classList]="[]"
                                                            matSuffix
                                                            aria-label="Description"
                                                            tabindex="-1"
                                                            [titleText]="editRecord.fields[fieldId].description"
                                                            *ngIf="editRecord.fields[fieldId].description"
                                                            [prefixIcon]="'info'"
                                                            [prefixIconType]="'material'"></material-button>
                                                    </div>
                                                    <span
                                                        *ngIf="
                                                            editRecord.fields[fieldId].mandatory &&
                                                            (!editRecord.fields[fieldId].message.errors ||
                                                                editRecord.fields[fieldId].message.errors.length === 0)
                                                        "
                                                        class="mat-form-field-subscript-wrapper requiredCls"
                                                        [textContent]="'*' + translateMsg('Required')"></span>
                                                    <div class="col-6 radioItem">
                                                        <material-radio-group
                                                            [radioOptions]="radioOptions"
                                                            [selectedValue]="editRecord.fields[fieldId].value"
                                                            (selectionChanged)="editRecord.fields[fieldId].value = $event"
                                                            [disabled]="editRecord.fields[fieldId].primaryKey && updateRecord"
                                                            [ariaLabelledBy]="fieldId"
                                                            [radioButtonClassList]="['radioButton']"
                                                            [radioGroupClassList]="['radioGroup']"></material-radio-group>
                                                    </div>
                                                    <mat-error
                                                        class="mat-form-field-subscript-wrapper requiredCls"
                                                        *ngIf="editRecord.fields[fieldId].message.errors.length > 0">
                                                        <span [textContent]="editRecord.fields[fieldId].message.errors[0]"></span>
                                                    </mat-error>
                                                </div>
                                            </ng-container>
                                            <ng-container
                                                *ngIf="
                                                    masterKeyMetaData[fieldId] !== undefined &&
                                                    masterKeyMetaData[fieldId].parentTableId === undefined &&
                                                    (masterKeyMetaData[fieldId].dataType === 'DOUBLE' ||
                                                        masterKeyMetaData[fieldId].dataType === 'FLOAT' ||
                                                        masterKeyMetaData[fieldId].dataType === 'INT' ||
                                                        masterKeyMetaData[fieldId].dataType === 'LONG')
                                                ">
                                                <material-input
                                                    [autofocus]="false"
                                                    class="col-4 masterField"
                                                    [placeholder]="editRecord.fields[fieldId].displayName"
                                                    [model]="editRecord.fields[fieldId].value"
                                                    (modelChange)="editRecord.fields[fieldId].value = $event"
                                                    [disabled]="editRecord.fields[fieldId].primaryKey && updateRecord"
                                                    [required]="editRecord.fields[fieldId].mandatory"
                                                    [errors]="editRecord.fields[fieldId].message.errors"
                                                    [warnings]="editRecord.fields[fieldId].message.warnings"
                                                    [description]="editRecord.fields[fieldId].description"></material-input>
                                            </ng-container>
                                            <ng-container
                                                *ngIf="
                                                    masterKeyMetaData[fieldId] !== undefined &&
                                                    masterKeyMetaData[fieldId].parentTableId === undefined &&
                                                    masterKeyMetaData[fieldId].dataType === 'DATE'
                                                ">
                                                <material-input-date
                                                    class="col-4 masterField"
                                                    [disabled]="editRecord.fields[fieldId].primaryKey && updateRecord"
                                                    [placeholder]="editRecord.fields[fieldId].displayName"
                                                    [label]="editRecord.fields[fieldId].displayName"
                                                    [model]="editRecord.fields[fieldId].value"
                                                    [errors]="editRecord.fields[fieldId].message.errors"
                                                    [warnings]="editRecord.fields[fieldId].message.warnings"
                                                    [required]="editRecord.fields[fieldId].mandatory"
                                                    [dateFormat]="editRecord.fields[fieldId].dateFormat"
                                                    (modelChange)="editRecord.fields[fieldId].value = $event"
                                                    [description]="editRecord.fields[fieldId].description"></material-input-date>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </div>
                                <div class="row col-12 masterFooter mt-2">
                                    <material-button
                                        class="inline-block mr-3"
                                        [buttonType]="'raised'"
                                        size="medium"
                                        [text]="translateMsg('Cancel')"
                                        (click)="toggleSliders()"></material-button>
                                    <material-button
                                        class="inline-block mr-3"
                                        [buttonType]="'raised'"
                                        size="medium"
                                        [text]="updateRecord ? translateMsg('Update') : translateMsg('Save')"
                                        color="primary"
                                        (buttonClicked)="submitMaster()"></material-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container
                *ngIf="
                    unassignMaster && !downloadMasterFlag && !uploadMasterFlag && !isUploadedFiles && !notificationFlag && !showRequests
                ">
                <div class="masterCard ps position-relative h-[calc(100vh-100px)]" [perfectScrollbar]>
                    <div>
                        <div class="masterAcionField" appRemoveAriaOwns>
                            <ng-container *ngIf="updateRecord">
                                <mat-selection-list #checklist [(ngModel)]="checkedList" (ngModelChange)="checkedChanged($event)">
                                    <mat-list-option
                                        class="parentOption"
                                        checkboxPosition="before"
                                        [value]="organization.id"
                                        [selected]="units_associated.indexOf(organization.id) !== -1 ? true : false">
                                        <span [textContent]="organization.name"></span>
                                    </mat-list-option>
                                    <mat-list-option
                                        class="childOption"
                                        checkboxPosition="before"
                                        *ngFor="let location of locationIdList"
                                        [value]="location.id"
                                        [selected]="units_associated.indexOf(location.id) !== -1 ? true : false">
                                        <span [textContent]="location.name"></span>
                                    </mat-list-option>
                                </mat-selection-list>
                            </ng-container>
                        </div>
                        <div class="row col-12 masterFooter">
                            <material-button
                                class="cancel"
                                [text]="translateMsg('Cancel')"
                                (buttonClicked)="toggleSliders()"></material-button>
                            <material-button *ngIf="!updateRecord" [text]="translateMsg('Update')"></material-button>
                            <material-button
                                *ngIf="updateRecord"
                                [text]="translateMsg('Update')"
                                (buttonClicked)="updateMasterData(checkedList)"></material-button>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="downloadMasterFlag && !uploadMasterFlag && !isUploadedFiles && !notificationFlag && !showRequests">
                <div class="userMainTableConatiner">
                    <div class="settingsHeader masterDataSettings">
                        <span
                            class="settingsNameText"
                            [textContent]="translateMsg('Download Master Data for') + ': ' + masterDataName"></span>
                        <div class="settingsDataActionsContainer">
                            <mat-icon [title]="translateMsg('Close')" class="closeIcon" (click)="toggleSliders()">cancel</mat-icon>
                        </div>
                    </div>
                    <div class="masterCard ps position-relative h-[calc(100vh-100px)]" [perfectScrollbar]>
                        <div>
                            <div class="masterAcionField">
                                <div class="col-12" *ngIf="_utils.isEmpty(outboundMappings)">
                                    <p>
                                        <label [textContent]="translateMsg('No Master Data')"></label>
                                    </p>
                                </div>
                                <div class="col-12" *ngIf="!_utils.isEmpty(outboundMappings)">
                                    <div class="col-4 outbound">
                                        <mat-form-field appRemoveAriaOwns>
                                            <mat-select
                                                [placeholder]="translateMsg('Select')"
                                                disableOptionCentering
                                                [id]="'selectDownload'"
                                                [(ngModel)]="masterDataOutboundMap"
                                                (ngModelChange)="selectedOutboundTransformation($event)"
                                                name="masterDownload"
                                                [disabled]="false">
                                                <ng-container *ngFor="let mapping of outboundMappings | ObjNgFor">
                                                    <mat-option [value]="mapping">
                                                        <span [textContent]="mapping"></span>
                                                    </mat-option>
                                                </ng-container>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-6 outbound" *ngIf="outboundTransformationSourceFile; else noTransformationSelected">
                                        <ng-container *ngIf="!showRefreshIcon">
                                            <material-button
                                                [titleText]="translateMsg('Generate Report')"
                                                [classList]="['actionButton', 'outbound']"
                                                buttonType="icon"
                                                size="small"
                                                color="default"
                                                (buttonClicked)="generateReport(masterDataOutboundMap)"
                                                prefixIcon="move_to_inbox"
                                                prefixIconType="material"></material-button>
                                        </ng-container>
                                        <ng-container *ngIf="showRefreshIcon">
                                            <material-button
                                                [titleText]="translateMsg('Refresh')"
                                                [classList]="['actionButton', 'outbound']"
                                                buttonType="icon"
                                                size="small"
                                                color="default"
                                                (buttonClicked)="getReportDetails(true, true)"
                                                prefixIcon="refresh"
                                                prefixIconType="material"></material-button>
                                        </ng-container>
                                        <label
                                            class="outbound"
                                            *ngIf="
                                                !_utils.isEmpty(masterDownloads) &&
                                                downloadMasterReports &&
                                                masterDownloads[masterDataOutboundMap]
                                            ">
                                            <span
                                                class="downloadFile"
                                                (click)="downloadOutboundFile(masterDataOutboundMap)"
                                                [title]="downloadReportName">
                                                <span [textContent]="downloadReportName"></span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="uploadMasterFlag && !isUploadedFiles && !notificationFlag && !showRequests">
                <div class="userMainTableConatiner">
                    <div class="settingsHeader masterDataSettings">
                        <span class="settingsNameText">
                            <span [textContent]="translateMsg('Upload Master Data for') + ':'"></span>
                            <span class="masterNameSpan" [textContent]="masterDataName"></span>
                        </span>
                        <div class="settingsDataActionsContainer">
                            <mat-icon [title]="translateMsg('Close')" class="closeIcon" aria-hidden="true" (click)="toggleSliders()">
                                cancel
                            </mat-icon>
                        </div>
                    </div>
                    <div class="masterCard ps position-relative h-[calc(100vh-155px)]" [perfectScrollbar]>
                        <div>
                            <div class="masterAcionField">
                                <div class="col-12" *ngIf="!_utils.isEmpty(mappings)">
                                    <div class="col-4 outbound">
                                        <material-select
                                            [options]="transformedMappings"
                                            [placeholder]="translateMsg('Select Transformation')"
                                            [name]="'selecteUpload'"
                                            [optionDisplayNameProperty]="'displayName'"
                                            [optionValueProperty]="'id'"
                                            [required]="false"
                                            [model]="masterDataMap"
                                            (modelChange)="selectedTransformation($event)"></material-select>
                                        <div *ngIf="!mapingSelected" class="mapingSelected">
                                            <span [textContent]="translateMsg('*Please select transformation')"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" *ngIf="transformationSourceFile">
                                    <table aria-describedby="commonmasters table" class="table uploadTable">
                                        <thead>
                                            <tr>
                                                <th scope="col" [textContent]="translateMsg('Source Name')"></th>
                                                <th scope="col" colspan="2" [textContent]="translateMsg('Supported Format')"></th>
                                                <th scope="col" [textContent]="translateMsg('Download Source Templates')"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let source of mappings[masterDataMap]['sourceParts']">
                                                <td class="uploadTd" [textContent]="source.name"></td>
                                                <td class="uploadTd">
                                                    <label class="uploadFormat" [textContent]="source.sourceDataFormat"></label>
                                                </td>
                                                <td class="uploadTd d-flex align-items-center">
                                                    <span class="tableFilesUploadContainer mr-3" [title]="fileName">
                                                        <app-file-upload
                                                            [data]="mastersUploadData"
                                                            [clearFiles]="clearFiles"
                                                            (newValue)="files = $event; uploadMaster()"
                                                            (fileName)="fileName = $event"></app-file-upload>
                                                    </span>
                                                    <span class="tableFilesName" [title]="fileName || '--'" [textContent]="fileName"></span>
                                                </td>
                                                <td class="uploadTd">
                                                    <span
                                                        class="downloadFile"
                                                        (click)="getSourceFile(masterDataMap, source)"
                                                        [textContent]="translateMsg('Download')"></span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="row col-12 masterFooter">
                                <div class="text-right">
                                    <material-button
                                        class="inline-block mr-3"
                                        [text]="translateMsg('Cancel')"
                                        (buttonClicked)="toggleSliders()"></material-button>
                                    <material-button
                                        class="inline-block mr-3"
                                        color="primary"
                                        [text]="translateMsg('Upload')"
                                        [disabled]="!transformationSourceFile"
                                        (buttonClicked)="uploadMasterData(masterDataMap)"></material-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="isUploadedFiles">
                <div class="userMainTableConatiner">
                    <div class="settingsHeader masterDataSettings">
                        <span
                            class="settingsNameText"
                            [textContent]="translateMsg('User Uploaded Files for') + ': ' + masterDataName"></span>
                        <div class="settingsDataActionsContainer">
                            <mat-icon [title]="translateMsg('Close')" class="closeIcon" aria-hidden="true" (click)="toggleSliders()">
                                cancel
                            </mat-icon>
                        </div>
                    </div>
                    <div class="masterCard ps position-relative h-[calc(100vh-120px)]" [perfectScrollbar]>
                        <div>
                            <div class="masterAcionField">
                                <div class="col-12" *ngIf="!hasChecksum">
                                    <p>
                                        <label [textContent]="translateMsg('No Files available')"></label>
                                    </p>
                                </div>
                                <div class="col-12 tablePosition" *ngIf="hasChecksum">
                                    <material-table
                                        [allTableColumns]="allColumns"
                                        [selectedColumns]="selectedFileUploadColumns"
                                        [data]="fileDetailstableData"
                                        (downloadFile)="onDownloadToggle($event)"
                                        [defaultPaginator]="true"></material-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="synchronizeFlag">
                <div class="masterCard synchronizeMasterCard ps position-relative">
                    <div id="inboundIntegrationsPageContainer">
                        <div class="inboundIntegrationsContainer">
                            <ng-container *ngIf="record && transformationMappings">
                                <app-integrations-template
                                    [subTenants]="subTenants"
                                    [masterTables]="allMasters"
                                    [title]="translateMsg('Synchronize Master for') + ': ' + masterDataName"
                                    [record]="record"
                                    [config]="config"
                                    [app]="app"
                                    [subApp]="subApp"
                                    [master]="selectedMasterTable"
                                    [masterTableColumns]="masterTableColumns"
                                    [sources]="sources"
                                    [bridge]="bridge"
                                    [openWidget]="true"
                                    [drawer]="drawer"
                                    [transformationMappings]="transformationMappings"
                                    (gotoIntegrationsPage)="toggleSliders($event)"
                                    [chains]="chains"></app-integrations-template>
                                <div class="inboundIntegrationsFooterContainer !pr-[20px]">
                                    <material-button
                                        class="inline-block mr-3"
                                        [text]="translateMsg('Cancel')"
                                        (buttonClicked)="toggleSliders()"></material-button>
                                    <material-button
                                        class="inline-block mr-3"
                                        [text]="translateMsg('Delete')"
                                        [hidden]="!record || !record.originalData || !record.originalData.locationId"
                                        (buttonClicked)="deleteConfiguration($event)"></material-button>
                                    <ng-container *ngIf="canShowImmediateTrigger()">
                                        <material-button
                                            class="inline-block mr-3"
                                            [text]="translateMsg('Sync Now')"
                                            color="primary"
                                            (buttonClicked)="initiateTrigger()"></material-button>
                                    </ng-container>
                                    <material-button
                                        class="inline-block mr-3"
                                        [text]="
                                            record && record.originalData.serviceId && record.originalData.serviceId.length > 0
                                                ? translateMsg('Update')
                                                : translateMsg('Save')
                                        "
                                        color="primary"
                                        (buttonClicked)="submitConfiguration()"></material-button>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="notificationFlag">
                <div class="notifyContainer">
                    <div class="notifyMainContainer userMainTableConatiner">
                        <div class="settingsHeader">
                            <span class="settingsNameText" [textContent]="translateMsg('Notifications')"></span>
                        </div>
                        <div class="closeNotification cursorPointer">
                            <mat-icon [title]="translateMsg('Close')" class="closeIcon" aria-hidden="true" (click)="toggleSliders()">
                                cancel
                            </mat-icon>
                        </div>
                        <div class="notifyContentContainer">
                            <app-common-notifications-eventlogs
                                [resourceId]="selectedMasterTable?.['itemId']"
                                [sourcePage]="'masters'"></app-common-notifications-eventlogs>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="showRequests">
                <div class="userMainTableConatiner masterRequestsTable">
                    <div class="settingsHeader masterDataSettings">
                        <div class="flex justify-between">
                            <span class="settingsNameText" [textContent]="translateMsg('Requests') + ' : ' + masterDataName"></span>
                            <div class="flex items-center">
                                <div class="masterDateSearchDiv">
                                    <div class="searchModeSuffix cursorPointer masterDateFilter displyInlineBlock" *ngIf="searchMode">
                                        <span [textContent]="translateMsg('In Search Mode')"></span>
                                    </div>
                                    <div
                                        class="clearSearchSuffix cursorPointer masterDateFilter displyInlineBlock"
                                        [title]="translateMsg('Clear')"
                                        (click)="clearAllFilters()"
                                        *ngIf="searchMode">
                                        <span [textContent]="translateMsg('Clear')"></span>
                                    </div>
                                    <span class="masterDateFilter">
                                        <app-date-filter
                                            [isModal]="isFromEnInvoice"
                                            [timeFilter]="timeFilter"
                                            (onSearchByTimeRange)="searchByTimeRange($event)"
                                            (onClearSearch)="clearAllFilters()"></app-date-filter>
                                    </span>
                                </div>
                                <div class="mr-[10px]">
                                    <mat-icon [title]="translateMsg('Refresh')" class="mr-[12px]" (click)="clearAllFilters()">
                                        refresh
                                    </mat-icon>
                                    <mat-icon [title]="translateMsg('Close')" aria-hidden="true" (click)="toggleSliders('requests')">
                                        cancel
                                    </mat-icon>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="masterCard ps position-relative">
                        <div *ngIf="requestsPagination?.count > 0; else noRequests">
                            <div class="masterAcionField">
                                <div class="col-12 tablePosition">
                                    <material-table
                                        [allTableColumns]="allMasterRequestColumns"
                                        [selectedColumns]="selectedMasterRequestColumns"
                                        [data]="requeststableData"
                                        [noRecordMsg]="'No Inbound Transmissions Available'"
                                        (downloadFile)="downloadFile($event)"
                                        [recordActions]="masterRequestrecordActions"
                                        [defaultPaginator]="true"
                                        [pageIndexSelected]="requestsPagination.pageIndex + 1"
                                        [customPageIndex]="requestsPagination.pages"
                                        [newCustomPaginator]="true"
                                        [hidePaginator]="true"
                                        [defaultPaginator]="false"
                                        (fetchItemsInPage)="fetchMasterRequestsInPage($event)"
                                        (refreshItemsWithNewPageSize)="refreshMasteritemsWithNewPageSize($event)"
                                        [sizeSelected]="requestsPagination.size"
                                        [disablePrevious]="requestsPagination.pageIndex === 0"
                                        [disableNext]="requestsPagination.disableNext"
                                        (fetchItemsInPageWithPageIndex)="fetchMasterRequestsInPage($event - 1)"></material-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </mat-drawer>
        <mat-drawer-content>
            <ng-container>
                <div class="userMainTableConatiner" id="masterTable">
                    <div class="settingsHeader masterSettingHeader masterDataSettings">
                        <div class="selectedMasterNameCls">
                            <ng-container *ngIf="selectedMasterTable?.itemName; else noMasterSelected">
                                <span
                                    class="settingsNameText"
                                    [matTooltip]="
                                        translateMsg('Master Data Column Definitions') +
                                        ' : ' +
                                        (selectedMasterTable?.displayName || selectedMasterTable?.itemName)
                                    "
                                    [textContent]="
                                        translateMsg('Master Data Column Definitions') +
                                        ' : ' +
                                        (selectedMasterTable?.displayName || selectedMasterTable?.itemName)
                                    "></span>
                            </ng-container>
                        </div>
                        <div
                            class="settingsDataActionsContainer masterSettingDataActionCls"
                            *ngIf="isFromEnComply || instanceId || isFromEnInvoice">
                            <mat-icon
                                [title]="isFromEnComply ? translateMsg('Back to master list') : translateMsg('Close')"
                                class="closeIcon"
                                aria-hidden="true"
                                (click)="clearMastersPage()">
                                cancel
                            </mat-icon>
                        </div>
                        <div class="allMastersDropdownContainer">
                            <material-menu-button
                                [buttonType]="'flat'"
                                [classList]="[]"
                                [textClassList]="['font-bold', 'text-[13px]']"
                                [labelClassList]="['!gap-0', '!p-0']"
                                [arrowClassList]="'!text-[24px]'"
                                [hideRipple]="true"
                                [showArrows]="true"
                                [arrowIconAppearance]="'filled'"
                                [text]="translateMsg('Change Master')"
                                [xPosition]="'before'">
                                <div class="allMastersList">
                                    <div class="mastersSearch px-3" stop-propagation>
                                        <mat-form-field>
                                            <input
                                                matInput
                                                [placeholder]="translateMsg('Search Master')"
                                                type="text"
                                                [(ngModel)]="masterSearchText"
                                                #masterSearchInput
                                                (blur)="focusSearchField()" />
                                            <material-button
                                                buttonType="icon"
                                                matSuffix
                                                size="small"
                                                [titleText]="'Clear'"
                                                (click)="clearMasterMenuSearch()"
                                                [prefixIcon]="masterSearchText?.length > 0 ? 'close' : 'search'"
                                                prefixIconType="material"></material-button>
                                        </mat-form-field>
                                    </div>
                                    <ng-container *ngFor="let master of allMasters | FilterPipe : 'displayName' : masterSearchText">
                                        <button
                                            [class.activeMasterItem]="selectedMasterTable?.id === master.id"
                                            class="hover:!bg-[#0000000a]"
                                            mat-menu-item
                                            (click)="onMasterSelect(master.itemName)"
                                            [title]="master.displayName">
                                            <span [textContent]="master.displayName"></span>
                                        </button>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="
                                            masterSearchText && (allMasters | FilterPipe : 'displayName' : masterSearchText)?.length === 0
                                        ">
                                        <div class="d-flex justify-content-center noRecords">
                                            <span [textContent]="translateMsg('No masters found')"></span>
                                        </div>
                                    </ng-container>
                                </div>
                            </material-menu-button>
                        </div>
                    </div>
                </div>
                <div class="masterCard ps position-relative">
                    <div class="masterChildContainer col-12">
                        <div class="col-12 childMasterRow">
                            <div *ngIf="selectedMasterTable?.itemName && (location === '' || location === undefined)" class="childAction">
                                <material-button
                                    [buttonType]="'icon'"
                                    [size]="'small'"
                                    color="primary"
                                    [classList]="['actionButton', 'masterRequestIconButton']"
                                    [titleText]="translateMsg('View Requests')"
                                    (buttonClicked)="actionMaster('requests')"
                                    [prefixIconType]="'image'"
                                    [prefixImgSrc]="'/assets/images/inbound-icon-white.png'"></material-button>
                                <material-button
                                    [buttonType]="'icon'"
                                    [size]="'small'"
                                    [prefixIconAppearance]="'filled'"
                                    color="primary"
                                    [classList]="['actionButton']"
                                    [titleText]="translateMsg('Notification')"
                                    (buttonClicked)="actionMaster('notification')"
                                    [prefixIcon]="'notifications'"
                                    [prefixIconType]="'material'"></material-button>
                                <material-button
                                    [buttonType]="'icon'"
                                    [size]="'small'"
                                    [prefixIconAppearance]="'filled'"
                                    color="primary"
                                    [classList]="['actionButton']"
                                    [titleText]="translateMsg('Search')"
                                    (buttonClicked)="actionMaster('search')"
                                    [prefixIcon]="'search'"
                                    [prefixIconType]="'material'"></material-button>
                                <material-button
                                    [buttonType]="'icon'"
                                    [size]="'small'"
                                    [prefixIconAppearance]="'filled'"
                                    [classList]="['actionButton']"
                                    [titleText]="translateMsg('Clear Search/Filter')"
                                    (buttonClicked)="actionMaster('clearsearch')"
                                    [disabled]="
                                        !(searchQuery && searchQuery.rules && searchQuery.rules.length) &&
                                        !(sortQuery && sortQuery.rules && sortQuery.rules.length) &&
                                        !defaultFilter &&
                                        !validationFilter
                                    "
                                    [prefixIcon]="'close'"
                                    [prefixIconType]="'material'"
                                    [ngClass]="{
                                        disable:
                                            !(searchQuery && searchQuery.rules && searchQuery.rules.length) &&
                                            !(sortQuery && sortQuery.rules && sortQuery.rules.length) &&
                                            !defaultFilter &&
                                            !validationFilter
                                    }"></material-button>
                                <material-button
                                    [buttonType]="'icon'"
                                    [size]="'small'"
                                    color="primary"
                                    [prefixIconAppearance]="'filled'"
                                    [classList]="['actionButton']"
                                    [titleText]="translateMsg('Index Data')"
                                    (buttonClicked)="actionMaster('index')"
                                    [prefixIcon]="'view_list'"
                                    [prefixIconType]="'material'"></material-button>
                                <material-button
                                    [buttonType]="'icon'"
                                    [size]="'small'"
                                    color="primary"
                                    [prefixIconAppearance]="'filled'"
                                    [classList]="['actionButton']"
                                    [titleText]="translateMsg('Synchronize')"
                                    (buttonClicked)="actionMaster('synchronize')"
                                    [disabled]="allPermissions?.indexOf(actions_list.update_record) === -1"
                                    [prefixIcon]="'settings_input_antenna'"
                                    [prefixIconType]="'material'"
                                    [ngClass]="{ disable: allPermissions?.indexOf(actions_list.update_record) === -1 }"></material-button>
                                <material-button
                                    [buttonType]="'icon'"
                                    [size]="'small'"
                                    color="primary"
                                    [prefixIconAppearance]="'filled'"
                                    [classList]="['actionButton']"
                                    [titleText]="translateMsg('Uploaded Files')"
                                    (buttonClicked)="actionMaster('uploadedfiles')"
                                    [disabled]="allPermissions?.indexOf(actions_list.update_record) === -1"
                                    [prefixIcon]="'assignment_turned_in'"
                                    [prefixIconType]="'material'"
                                    [ngClass]="{ disable: allPermissions?.indexOf(actions_list.update_record) === -1 }"></material-button>
                                <material-button
                                    [buttonType]="'icon'"
                                    [size]="'small'"
                                    color="primary"
                                    [prefixIconAppearance]="'filled'"
                                    [classList]="['actionButton']"
                                    [titleText]="translateMsg('Download')"
                                    [matMenu]="masterDownloadMenu"
                                    [prefixIcon]="'work'"
                                    [prefixIconType]="'material'"
                                    (buttonClicked)="actionMaster('download')"></material-button>
                                <mat-menu class="mastersReportsDownloadMenu !bg-white" #masterDownloadMenu="matMenu" xPosition="before">
                                    <button class="reportsBtn" mat-menu-item *ngFor="let mapping of outboundMappings | ObjNgFor">
                                        <span class="d-flex justify-content-between">
                                            <span
                                                class="mr-3 text-truncate mastersReportName"
                                                [title]="(chainNamesVsDiplayNames && chainNamesVsDiplayNames[mapping]) || mapping">
                                                <span
                                                    [textContent]="
                                                        (chainNamesVsDiplayNames && chainNamesVsDiplayNames[mapping]) || mapping
                                                    "></span>
                                            </span>
                                            <span class="d-flex justify-content-between align-items-center">
                                                <ng-container *ngIf="masterDownloadsFlatMap[mapping]; else noMaster">
                                                    <span
                                                        class="material-icons mr-3"
                                                        (click)="downloadOutboundFile(outboundMappings[mapping]?.chainName)"
                                                        stop-propagation>
                                                        cloud_download
                                                    </span>
                                                </ng-container>
                                                <ng-template #noMaster>--</ng-template>
                                                <span class="material-icons" (click)="generateReport(mapping)" stop-propagation>
                                                    refresh
                                                </span>
                                            </span>
                                        </span>
                                    </button>
                                </mat-menu>
                                <material-button
                                    [buttonType]="'icon'"
                                    [size]="'small'"
                                    color="primary"
                                    [prefixIconAppearance]="'filled'"
                                    [classList]="['actionButton']"
                                    [titleText]="translateMsg('Upload')"
                                    (buttonClicked)="actionMaster('upload')"
                                    [disabled]="allPermissions?.indexOf(actions_list.update_record) === -1"
                                    [prefixIcon]="'cloud_upload'"
                                    [prefixIconType]="'material'"
                                    [ngClass]="{ disable: allPermissions?.indexOf(actions_list.update_record) === -1 }"></material-button>
                                <material-button
                                    [buttonType]="'icon'"
                                    [size]="'small'"
                                    [prefixIconAppearance]="'filled'"
                                    [classList]="['actionButton']"
                                    [titleText]="translateMsg('Delete')"
                                    (buttonClicked)="actionMaster('delete')"
                                    [disabled]="allPermissions?.indexOf(actions_list.delete_record) === -1 || selectedRecordsCount === 0"
                                    [prefixIcon]="'delete'"
                                    [prefixIconType]="'material'"></material-button>
                                <material-button
                                    [buttonType]="'icon'"
                                    [size]="'small'"
                                    color="primary"
                                    [prefixIconAppearance]="'filled'"
                                    [classList]="['actionButton']"
                                    [titleText]="translateMsg('Edit')"
                                    (buttonClicked)="actionMaster('edit')"
                                    [disabled]="allPermissions?.indexOf(actions_list.update_record) === -1 || selectedRecordsCount !== 1"
                                    [prefixIcon]="'edit'"
                                    [prefixIconType]="'material'"></material-button>
                                <material-button
                                    [buttonType]="'icon'"
                                    [size]="'small'"
                                    color="primary"
                                    [prefixIconAppearance]="'filled'"
                                    [classList]="['actionButton']"
                                    [titleText]="translateMsg('Add')"
                                    (buttonClicked)="actionMaster('add')"
                                    [disabled]="list.length !== 0"
                                    [prefixIcon]="'add_circle'"
                                    [prefixIconType]="'material'"
                                    [ngClass]="{ disable: list.length !== 0 }"></material-button>
                                <material-button
                                    [buttonType]="'icon'"
                                    [size]="'small'"
                                    color="primary"
                                    [prefixIconAppearance]="'filled'"
                                    [classList]="['actionButton']"
                                    [titleText]="translateMsg('Refresh')"
                                    (buttonClicked)="actionMaster('refresh')"
                                    [prefixIcon]="'refresh'"
                                    [prefixIconType]="'material'"></material-button>
                            </div>
                        </div>
                        <div class="row col-12 childMasterRow">
                            <div class="mastersContainerRow" *ngIf="allMasters?.length > 0; else noMastersBlock">
                                <div class="masterData">
                                    <ng-container *ngIf="_utils.isEmpty(selectedMasterTable); else noRecordLength">
                                        <div class="noMasterRecordContainer mt-[15%]">
                                            <div class="noMasterRecordDiv d-flex justify-content-center align-items-center">
                                                <span
                                                    [textContent]="
                                                        translateMsg('Select any master from Change Master menu to view data')
                                                    "></span>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                                <div class="col-9 masterData">
                                    <ng-template #noRecordLength>
                                        <div
                                            *ngIf="records.length !== 0 || pagination.count !== 0; else noRecordBlock"
                                            class="masterTable"
                                            [ngClass]="{ enInvoiceMasterTable: isFromEnInvoice }">
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    openDrawer ? noRecordBlock : tableTemplate;
                                                    context: { record: editRecord }
                                                "></ng-container>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </mat-drawer-content>
    </mat-drawer-container>
</div>

<ng-template #noRecordBlock>
    <div class="centerDiv">
        <div
            class="noRecords"
            *ngIf="!_utils.isEmpty(selectedMasterTable) && records?.length === 0 && !editRecord?.hasFields && !showRequests">
            <span class="material-icons" [textContent]="noRecordsIcon"></span>
            <div [textContent]="noRecordsText"></div>
        </div>
    </div>
</ng-template>

<ng-template #tableTemplate>
    <material-table
        [allTableColumns]="allTableColumns"
        [selectedColumns]="selectedColumns"
        [data]="tableData"
        [recordActions]="tableRecordActions"
        [pageIndexSelected]="pagination.pageIndex + 1"
        [customPageIndex]="pagination.pages"
        [newCustomPaginator]="true"
        [hidePaginator]="true"
        [defaultPaginator]="false"
        [passwordColumns]="passwordColumns"
        [sizeSelected]="pagination.size"
        [disablePrevious]="pagination.pageIndex === 0"
        [disableNext]="pagination.disableNext"
        (fetchItemsInPage)="fetchItemsInPage($event)"
        (refreshItemsWithNewPageSize)="refreshItemsWithNewPageSize($event)"
        (fetchItemsInPageWithPageIndex)="fetchItemsInPage($event - 1)"
        (recordSelectedEvent)="recordSelectedEvent($event)"
        (onDoubleClickEvent)="onRecordSelect($event)"></material-table>
</ng-template>

<ng-template #masterConfigField let-record="configRecord" let-field="field" let-hide="hide">
    <app-integrations-field-template
        [subTenants]="subTenants"
        [masterTables]="allMasters"
        [record]="$any(configRecord)"
        [field]="field"
        [hide]="hide"
        [configuredRecords]="configuredRecords"
        (apiConfigChange)="apiConfigChange($event)"></app-integrations-field-template>
</ng-template>

<ng-template #masterSubSections let-record="configRecord" let-subSection="subSection">
    <ng-container *ngIf="!hideSubSection(subSection, configRecord)">
        <ng-container [ngSwitch]="subSection.structure">
            <ng-container *ngSwitchCase="'FLEX_FORM'">
                <ng-container
                    *ngTemplateOutlet="flexFormStructure; context: { configRecord: configRecord, subSection: subSection }"></ng-container>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #flexFormStructure let-record="configRecord" let-subSection="subSection">
    <div class="flexFormContainer">
        <ng-container *ngIf="subSection.fields && subSection.fields.length > 0">
            <ng-container *ngFor="let field of subSection.fields; let i = index">
                <ng-container *ngIf="!hideField(field, $any(record))">
                    <div class="inboundIntegrationFieldContainer">
                        <ng-container
                            *ngTemplateOutlet="integrationField; context: { configRecord: configRecord, field: field }"></ng-container>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #integrationField let-record="configRecord" let-field="field" let-hide="hide">
    <app-integrations-field-template
        [subTenants]="subTenants"
        [masterTables]="allMasters"
        [record]="$any(configRecord)"
        [field]="field"
        [hide]="hide"
        [configuredRecords]="configuredRecords"
        (apiConfigChange)="apiConfigChange($event)"></app-integrations-field-template>
</ng-template>

<mat-menu #messagesMenu="matMenu" xPosition="before" class="messagesMenuMainContainer">
    <div class="messagesMainContainer" *ngIf="editRecord?.errors" [ngClass]="{ errorMenuMessages: editRecord.errors.length }">
        <span #messagesContainer>
            <ng-container *ngIf="editRecord?.errors?.length > 0">
                <div class="mat-menu-head errors" stop-propagation>
                    <span [textContent]="translateMsg('Errors')"></span>
                </div>
                <div class="mat-menu-body messagesContainer" stop-propagation [class.hasWarnings]="editRecord.warnings.length > 0">
                    <ng-container *ngFor="let alert of editRecord?.errors; let i = index">
                        <div class="messageContainer">
                            <span class="messageIndex" [textContent]="i + 1 + '.'"></span>
                            <span class="messageBody word-break" [textContent]="alert"></span>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="editRecord?.warnings?.length > 0">
                <div class="mat-menu-head warnings" stop-propagation>
                    <span [textContent]="translateMsg('Warnings')"></span>
                </div>
                <div class="mat-menu-body messagesContainer" stop-propagation [class.hasWarnings]="editRecord.warnings.length > 0">
                    <ng-container *ngFor="let alert of editRecord.warnings; let i = index; trackBy: trackByIndexMethod">
                        <div class="messageContainer">
                            <span class="messageIndex" [textContent]="i + 1 + '.'"></span>
                            <span class="messageBody word-break" [textContent]="alert"></span>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </span>
    </div>
</mat-menu>

<ng-template #noMasterSelected>
    <span class="settingsNameText" [textContent]="translateMsg('Masters')"></span>
</ng-template>

<ng-template #noMasterRecords>
    <div class="noMasterRecordContainer">
        <div class="noMasterRecordDiv d-flex justify-content-center align-items-center">
            <span [textContent]="translateMsg('No records found')"></span>
        </div>
    </div>
</ng-template>

<ng-template #noMastersBlock>
    <div class="noMasterRecordContainer mt-[15%]">
        <div class="noMasterRecordDiv d-flex justify-content-center align-items-center">
            <span [textContent]="translateMsg('No masters found')"></span>
        </div>
    </div>
</ng-template>

<ng-template #noRequests>
    <div class="noMasterRecordContainer mt-[15%]">
        <div class="noMasterRecordDiv d-flex justify-content-center align-items-center">
            <span class="text-lg font-bold" [textContent]="translateMsg('No requests found')"></span>
        </div>
    </div>
</ng-template>

<ng-template #noTransformationSelected>
    <div class="noMasterRecordContainer">
        <div class="noMasterRecordDiv d-flex justify-content-center align-items-center">
            <span [textContent]="translateMsg('Please select transformation to download reports.')"></span>
        </div>
    </div>
</ng-template>
